import { request } from '../../utils/request';

export const addProductsHashtag = (body: { name: string }) =>
  request({
    method: 'POST',
    url: `/products/hash-tags`,
    formData: body,
    callback: undefined,
    onError: (err) => {
      throw err;
    },
  });
